import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        NgIdleKeepaliveModule.forRoot()
    ]
})
export class CoreModule { }
